
const { Swiper } = window;

const sliderDefault = {
    slidesPerView: 1,
    autoHeight: false,
    loop: true,
    spaceBetween: 0,
    speed: 300,
    breakpoints: {
        0: {
            slidesPerView: 2,
            spaceBetween: 12,
        },
        768: {
            slidesPerView: 3,
        },
        992: {
            slidesPerView: 4,
            spaceBetween: 24,
        },
        1200: {
            slidesPerView: 5,
            spaceBetween: 24,
        },
        1488: {
            slidesPerView: 6,
        }
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
};

class Slider {
    constructor(element, config) {
        this.element = element;
        this.config = { el: element, ...sliderDefault, ...config};
        this.instance = undefined;

        this.prepare();
        this.initSlider();
    }

    prepare() {

        // remove show classes
    }

    initSlider() {
        this.instance = new Swiper(this.config);
    }

    destroySlider() {
        if (this.instance) {
            this.instance.destroy();
        }
    }
};

export default Slider;
